/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import { 
  useDispatch, 
  connect, 
  useSelector 
} from "react-redux";
// eslint-disable-next-line object-curly-newline
import { Row, Col, Card, CardBody, CardHeader, CardTitle, Nav, NavItem, NavLink } from "reactstrap";
import FeatherIcon from "feather-icons-react";

import AddDepositForm from "./AddDepositForm";
import {
  fetchDepositsStart,
  depositRejectStart,
  depositApproveStart,
  depositEditStart,
} from "store/transactions/deposit/action";
import SearchBar from "components/Common/SearchBar";
import CustomPagination from "components/Common/CustomPagination";
// eslint-disable-next-line object-curly-newline
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import TableLoader from "components/Common/TableLoader";
import Notification from "components/Common/Notification";
import logo from "../../../assets/images/logo-sm.svg";
import { withTranslation } from "react-i18next";
import { checkAllBoxes } from "common/utils/checkAllBoxes";
import { Link } from "react-router-dom";
import { captilazeFirstLetter } from "common/utils/manipulateString";
import Filter from "./DepositFilter";
import Badge from "components/Common/Badge";
import { formatDateBroker } from "helpers/formatDate";
import ReceiptModal from "../Forex/ReceiptModal";
import TransactionModal from "components/Common/TransactionModal";
import CustomDropDownEdit from "components/Common/CustomDropDownEdit";
import Withdrawal from "./Withdrawal";
import classNames from "classnames";
import { 
  fixingAmount,
  getBaseCurrency,
  getRowCurrency
} from "common/utils/FixedAmount";

function Deposit(props) {
  const dispatch = useDispatch();
  const [searchInput, setSearchInput] = useState("");
  const [showNotication, setShowNotifaction] = useState(false);
  const [detailsModal, setDetailsModal] = useState(false);
  const [selectedContent, setSelectedContent] = useState("");
  const [sizePerPage, setSizePerPage] = useState(10);
  const [selected, setSelected] = useState("LIVE");
  const [approveModal, setApproveModal] = useState(false);
  const [selectedDeposit, setSelectedDeposit] = useState({});
  const [rejectModal, setRejectModal] = useState(false);
  const [editModal, setEditModal] = useState(false);


  const [walletType, setalletType] = useState("customers");

  const toggle = (tab) => {
    if (walletType !== tab) {
      setalletType(tab);
    }
  };

  const columns = [
    {
      dataField: "checkbox",
      text: (
        <input
          type="checkbox"
          id="check-all-deposits"
          onChange={() =>
            checkAllBoxes("check-all-deposits", ".deposit-checkbox")
          }
        />
      ),
    },
    {
      dataField: "recordId",
      text: props.t("Transaction Id"),
    },
    {
      dataField: "createdAt",
      text: props.t("Date"),
      formatter: (val) => formatDateBroker(val.createdAt),
    },
    {
      dataField: "updatedAt",
      text: props.t("Approval/Reject Date"),
      formatter: (val) => val?.status === "PENDING" ?  "-" : formatDateBroker(val.updatedAt),
    },
    {
      dataField: "customerId",
      text: props.t("Client"),
      formatter: (val) => {
        return (
          <div>
            <Link
              to={{
                pathname: `/clients/${val?.customerId?._id}/profile`,
                state: { clientId: val.customerId },
              }}
            >
              <i className="no-italics fw-bold">
                {val.customerId
                  ? `${captilazeFirstLetter(
                    val.customerId.firstName
                  )} ${captilazeFirstLetter(val.customerId.lastName)}`
                  : ""}
              </i>
            </Link>
          </div>
        );
      },
    },
    {
      dataField: "gateway",
      text: props.t("Gateway"),
      formatter: (val) =>
        val.gateway == "WIRE_TRANSFER"
          ? "Wire"
          : val.gateway?.split("_").join(" ")?.toLowerCase(),
    },
    {
      dataField: "currency",
      text: props.t("Currency"),
      formatter: (val) => getRowCurrency(val),
    },
    {
      dataField: "reason",
      text: props.t("Reason"),
      formatter: (val) =>
        val.reason ? (
          <div data-title={val.reason}>
            {val.reason.length > 20
              ? `${val.reason.slice(0, 20)}...`
              : val.reason}
          </div>
        ) : (
          <>{val?.note}</>
        ),
    },
    {
      dataField: "initAmount",
      text: props.t("Initial Amount"),
      formatter: (val) => (
        fixingAmount(val?.initAmount?.$numberDecimal || val.initAmount)
      )
    },
    {
      dataField: "amount",
      text: props.t("Amount"),
      formatter: (val) => (
        fixingAmount(val?.amount?.$numberDecimal || val.amount)
      )
    },
    {
      dataField: "amount",
      text: props.t("Final Amount"),
      formatter: (val) => {
        const amount = Number(
          val?.amount?.$numberDecimal ?? val?.amount ?? 0
        );

        const fee = Number(
          val?.fee?.$numberDecimal ??
          val?.fee ??
          val?.fees?.$numberDecimal ??
          val?.fees ??
          0
        );

        return fixingAmount(amount - fee);
      },
    },
     {
      dataField: "fee",
      text: props.t("Fee"),
      formatter: (val) => fixingAmount(
        val?.fee?.$numberDecimal || val?.fee || val?.fees?.$numberDecimal || val?.fees
      ),
    },
    {
      dataField: "currency",
      text: props.t("Base Currency"),
      formatter: (val) => getBaseCurrency(val),
    },
    {
      dataField: "paid",
      text: props.t("Paid Amount"),
      formatter: (val) => fixingAmount(val?.paid?.$numberDecimal || val?.paid),
    },
    {
      dataField: "status",
      text: props.t("Status"),
      formatter: (val) => <Badge status={props.t(val.status)}></Badge>,
    },
    {
      dataField: "bankReceipt",
      text: props.t("Bank Receipt"),
      formatter: (val) => {
        if (val?.receipt) {
          return (
            <div className="text-center">
              <div className={(["WIRE_TRANSFER", "UPI", "CRYPTO"].includes(val?.gateway) && val?.receipt) ? "text-success" : "text-muted "}
                style={{
                  cursor: "pointer",
                }}
              >
                <i
                  className="mdi mdi-eye font-size-20"
                  id="edittooltip"
                  onClick={() => {
                    if (val?.receipt) {
                      if (["WIRE_TRANSFER", "UPI", "CRYPTO"].includes(val?.gateway)) {
                        setDetailsModal(true);
                        setSelectedContent({
                          type: "image",
                          content: val?.receipt,
                        });
                      }
                    }
                  }}
                ></i>
              </div>
            </div>
          );
        } else {
          return (
            <div className="text-center">
              <div className={"text-muted "}>
                <i className="mdi mdi-eye font-size-20" id="edittooltip"></i>
              </div>
            </div>
          );
        }
      },
    },
    {
      dataField: "additionalDetails",
      text: props.t("Additional Details"),
      formatter: (val) => {
        if (val?.content || val?.rawData) {
          return (
            <div className="text-center">
              <div className={((["CRYPTO", "BLOCKCHAIN", "UPI", "WIRE_TRANSFER"].includes(val.gateway))  && val?.content) ? "text-success" : "text-muted "}
                style={{
                  cursor: "pointer",
                }}
              >
                <i
                  className="mdi mdi-eye font-size-20"
                  id="edittooltip"
                  onClick={() => {
                    if (val.gateway === "CRYPTO") {
                      setDetailsModal(true);
                      setSelectedContent({
                        type: "json",
                        content: val?.content,
                      });
                    } else if (val.gateway === "BLOCKCHAIN") {
                      setDetailsModal(true);
                      setSelectedContent({
                        type: "json",
                        content: {
                          network: `${val?.rawData?.data?.item?.network} ${val?.rawData?.data?.item?.unit}`,
                          referenceId: val?.rawData?.referenceId,
                          amount: val?.rawData?.data?.item?.amount,
                          address: val?.rawData?.data?.item?.address,
                          confirmations:
                            val?.rawData?.data?.item?.currentConfirmations,
                          requiredConfirmations:
                            val?.rawData?.data?.item?.targetConfirmations,
                          transactionId:
                            val?.rawData?.data?.item?.transactionId,
                        },
                      });
                    } else if (val.gateway === "UPI") {
                      setDetailsModal(true);
                      setSelectedContent({
                        type: "json",
                        content: val?.content,
                      });
                    } else if (val.gateway === "WIRE_TRANSFER") {
                      setDetailsModal(true);
                      setSelectedContent({
                        type: "json",
                        content: val?.content,
                      });
                    }
                  }}
                ></i>
              </div>
            </div>
          );
        } else {
          return (
            <div className="text-center">
              <div className={"text-muted "}>
                <i className="mdi mdi-eye font-size-20" id="edittooltip"></i>
              </div>
            </div>
          );
        }
      },
    },
    {
      dataField: "dropdown",
      isDummyField: true,
      editable: false,
      text: props.t("Actions"),
    },
  ];
  const initFilteredValues = {
    customerId: "",
    filterDate: {
      fromDate: "",
      toDate: "",
    },
    status: "",
    currency: "",
    amount: "",
    gateway: "",
    agent: "",
  };
  const [filteredValues, setFilteredValues] = useState(initFilteredValues);
  const filterChangeHandler = (filteredValuesData) => {
    setFilteredValues(filteredValuesData);
  };
  useEffect(() => {
    if (!detailsModal) loadDeposits(1, sizePerPage);
  }, [
    sizePerPage,
    1,
    searchInput,
    selected,
    props.depositResponseMessage,
    props.depositChangeStatusSuccess,
    filteredValues,
    walletType,
  ]);

  const handleSearchInput = (e) => {
    setSearchInput(e.target.value);
  };

  const loadDeposits = (page, limit) => {
    if (searchInput !== "" && searchInput.length >= 3) {
      dispatch(
        fetchDepositsStart({
          limit,
          page,
          type: selected,
          searchText: searchInput,
          filteredValues,
          walletType,
        })
      );
    } else if (searchInput === "") {
      dispatch(
        fetchDepositsStart({
          limit,
          page,
          type: selected,
          filteredValues,
          walletType,
        })
      );
    }
  };


  const depositApproveModal = (deposit) => {
    setSelectedDeposit(deposit);
    setApproveModal(true);
  };

  const depositRejectModal = (deposit) => {
    setSelectedDeposit(deposit);
    setRejectModal(true);
  };

  const depositEditModal = (deposit) => {
    setSelectedDeposit(deposit);
    setEditModal(true);
  };

  const approveDeposit = (deposit) => {
    dispatch(
      depositApproveStart({
        id: deposit._id,
        customerId: deposit.customerId._id,
        amount: deposit.amount,
        note: deposit.note
      })
    );
    setApproveModal(false);
  };

  const depositReject = (deposit) => {
    dispatch(
      depositRejectStart({
        id: deposit._id,
        customerId: deposit.customerId._id,
        note: deposit.note
      })
    );
    setRejectModal(false);
  };

  const depositEdit = async (deposit) => {
    dispatch(
      depositEditStart({
        id: deposit._id,
        customerId: deposit.customerId._id,
        note: deposit.note
      })
    );
    setEditModal(false);
  };

  const closeNotifaction = () => {
    setShowNotifaction(false);
  };

  return (
    <React.Fragment>
      <Notification
        onClose={closeNotifaction}
        body={props.t("The deposit has been updated successfully")}
        show={showNotication}
        header={props.t("Deposit Update")}
        logo={logo}
      />
      <Row>
        <Col className="col-12">
        
          <Card>
            <CardHeader className="d-flex flex-column gap-3 ">
              <div className="d-flex justify-content-between align-items-center">
                <CardTitle className="color-primary">
                  {props.t(`${props.t("Deposits")} (${props.totalDocs})`)}
                  <FeatherIcon
                    icon="refresh-cw"
                    className="icon-lg ms-2"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      loadDeposits(1, sizePerPage);
                    }}
                  />
                </CardTitle>
              </div>
              <div className="d-flex flex-row align-items-center justify-content-between gap-2">
                <div className="d-flex flex-row align-items-center">
                  <SearchBar
                    handleSearchInput={handleSearchInput}
                    placeholder={props.t("Enter Transaction Id")}
                  />
                  {/* <div>
                    <Dropdown
                      isOpen={btnprimary1}
                      toggle={() => setBtnprimary1(!btnprimary1)}
                    >
                      <DropdownToggle tag="button" className="btn btn-primary">
                        {selected} <i className="mdi mdi-chevron-down" />
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem value="LIVE" onClick={(e) => { setSelected(e.target.value) }}>Live</DropdownItem>
                        <DropdownItem value="DEMO" onClick={(e) => { setSelected(e.target.value) }}>Demo</DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </div> */}
                  <Filter
                    filterChangeHandler={filterChangeHandler}
                    filteredValues={filteredValues}
                  />
                </div>
                {walletType === "customers" && (
                  <div className="d-flex flex-row align-items-center justify-content-between">
                    <AddDepositForm />
                  </div>
                ) }
              </div>
            </CardHeader>

            <CardBody>
              <div className="table-rep-plugin">
                <div
                  className="table-responsive mb-0"
                  data-pattern="priority-columns"
                >
                  <Table id="tech-companies-1" className="table  table-hover ">
                    <Thead className="text-center table-light">
                      <Tr>
                        {columns.map((column, index) =>
                          <Th data-priority={index} key={index}><span className="color-primary">{column.text}</span></Th>
                        )}
                      </Tr>
                    </Thead>
                    {props.totalDocs === 0 ? (
                      <Tbody
                        style={{
                          fontSize: "12px",
                          textAlign: "center",
                          textTransform: "capitalize",
                        }}
                      >
                        {props.loading && <TableLoader colSpan={4} />}
                        {!props.loading && (
                          <>
                            <Tr>
                              <Td
                                colSpan={"100%"}
                                className="fw-bolder text-center"
                                st
                              >
                                <h3 className="fw-bolder text-center">
                                  {props.t("No records")}
                                </h3>
                              </Td>
                            </Tr>
                          </>
                        )}
                      </Tbody>
                    ) : (
                      <Tbody
                        style={{
                          fontSize: "12px",
                          textAlign: "center",
                          textTransform: "capitalize",
                        }}
                      >
                        {props.loading && <TableLoader colSpan={4} />}
                        {!props.loading &&
                          props.deposits.map((row, rowIndex) => (
                            <Tr key={rowIndex}>
                              {columns.map((column, index) => (
                                <Td
                                  key={`${rowIndex}-${index}`}
                                  className={`pt-4 ${column.dataField === "dropdown" &&
                                    "d-flex justify-content-center"
                                    }`}
                                >
                                  {column.dataField === "checkbox" ? (
                                    <input
                                      className="deposit-checkbox"
                                      type="checkbox"
                                    />
                                  ) : (
                                    ""
                                  )}
                                  {column.formatter
                                    ? column.formatter(row, rowIndex)
                                    : row[column.dataField]}
                                  {column.dataField === "dropdown" && (
                                    <CustomDropDownEdit
                                      permission={
                                        props.depositsPermissions.actions && !["FINITIC_PAY"].includes(row.gateway)
                                      }
                                      status={row.status}
                                      approve={() => depositApproveModal(row)}
                                      reject={() => depositRejectModal(row)}
                                      edit={() => depositEditModal(row)}
                                    />
                                  )}
                                </Td>
                              ))}
                            </Tr>
                          ))}
                      </Tbody>
                    )}
                  </Table>
                  <CustomPagination
                    {...props}
                    setSizePerPage={setSizePerPage}
                    sizePerPage={sizePerPage}
                    onChange={loadDeposits}
                    docs={props.deposits}
                  />
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      {/* {<DetailsModal rawData={selectedContent} open={detailsModal} onClose={() => setDetailsModal(false)} />} */}
      {selectedContent && (
        <ReceiptModal
          content={selectedContent}
          open={detailsModal}
          onClose={() => setDetailsModal(false)}
        />
      )}
      {approveModal && <TransactionModal
        show={approveModal}
        title={"Approve Deposit"}
        submitButton="Approve"
        showAmount={true}
        toggle={() => {
          setApproveModal(!approveModal);
        }}
        t={props.t}
        onSubmit={approveDeposit}
        data={selectedDeposit}
      >
      </TransactionModal>}
      {rejectModal && <TransactionModal
        show={rejectModal}
        title="Reject Deposit"
        submitButton="Reject"
        showAmount={false}
        toggle={() => {
          setRejectModal(!rejectModal);
        }}
        t={props.t}
        onSubmit={depositReject}
        data={selectedDeposit}
      >
      </TransactionModal>}
      {editModal && <TransactionModal
        show={editModal}
        title="Edit Note"
        submitButton="Edit"
        showAmount={false}
        toggle={() => {
          setEditModal(!editModal);
        }}
        t={props.t}
        onSubmit={depositEdit}
        data={selectedDeposit}
      >
      </TransactionModal>}
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  loading: state.depositReducer.loading || false,
  deposits: state.depositReducer.deposits || [],
  page: state.depositReducer.page || 1,
  totalDocs: state.depositReducer.totalDocs || 0,
  totalPages: state.depositReducer.totalPages || 0,
  hasNextPage: state.depositReducer.hasNextPage,
  hasPrevPage: state.depositReducer.hasPrevPage,
  limit: state.depositReducer.limit,
  nextPage: state.depositReducer.nextPage,
  pagingCounter: state.depositReducer.pagingCounter,
  prevPage: state.depositReducer.prevPage,
  depositsPermissions: state.Profile.depositsPermissions || {},
  depositResponseMessage: state.depositReducer.depositResponseMessage,
  depositChangeStatusSuccess: state.depositReducer.depositChangeStatusSuccess,
});
export default connect(mapStateToProps, null)(withTranslation()(Deposit));
